import { Map, List } from 'immutable';
import { MODAL_HIDE, MODAL_SHOW, START, SUCCESS, ERROR } from '../../consts';
import { INFRASTRUCTURE, MAPS, ANNOUNCEMENT_LOAD, TERRITORIAL_DIVISION } from './actionTypes';

const MODAL_STATE = new Map({
  open: false,
  realtyId: null,
  dealType: null,
  realtyType: null
});

const TERRITORIAL_STATE = new Map({
  open: false
});

const INFRASTRUCTURE_STATE = new Map({
  loading: false,
  realtyId: null,
  error: null,
  data: new Map({})
});

export const ANNOUNCEMENT_STATE = new Map({
  loading: 0,
  loaded: false,
  error: null,
  announcementList: new List()
});

const DEFAULT_STATE = new Map({
  modal: MODAL_STATE,
  infrastructure: INFRASTRUCTURE_STATE,
  announcement: ANNOUNCEMENT_STATE,
  territorialDivision: TERRITORIAL_STATE
});

export default function maps (state = DEFAULT_STATE, action) {
  switch (action.type) {
    case MAPS + MODAL_SHOW:
    case MAPS + MODAL_HIDE:
      const modalState = mapsModalReducer(state.get('modal'), action);
      return state.mergeIn(['modal'], modalState);

    case TERRITORIAL_DIVISION + MODAL_SHOW:
    case TERRITORIAL_DIVISION + MODAL_HIDE:
      const modalTDState = mapsModalTDReducer(state.get('territorialDivision'), action);
      return state.mergeIn(['territorialDivision'], modalTDState);

    case ANNOUNCEMENT_LOAD + START:
    case ANNOUNCEMENT_LOAD + SUCCESS:
    case ANNOUNCEMENT_LOAD + ERROR:
      const announcementState = announcementReducer(state.get('announcement'), action);
      return state.mergeIn(['announcement'], announcementState);

    case INFRASTRUCTURE + START:
    case INFRASTRUCTURE + SUCCESS:
    case INFRASTRUCTURE + ERROR:
      const infrastructureState = infrastructureReducer(state.get('infrastructure'), action);
      return state.mergeIn(['infrastructure'], infrastructureState);

    default:
      return state;
  }
}

function mapsModalReducer (state, action) {
  switch (action.type) {
    case MAPS + MODAL_SHOW:
      return state
        .merge({open: true})
        .merge(action.payload);
    case MAPS + MODAL_HIDE:
      return MODAL_STATE;
    default:
      return state;
  }
}

function mapsModalTDReducer (state, action) {
  switch (action.type) {
    case TERRITORIAL_DIVISION + MODAL_SHOW:
      return state.set('open', true);
    case TERRITORIAL_DIVISION + MODAL_HIDE:
      return state.set('open', false);
    default:
      return state;
  }
}

function announcementReducer (state, action) {
  switch (action.type) {
    // загрузка объявлений
    case ANNOUNCEMENT_LOAD + START:
      return state.merge({
        loading: state.get('loading') + 1,
        error: null
      });
    case ANNOUNCEMENT_LOAD + SUCCESS:
      return state.merge({
        loading: state.get('loading') - 1,
        loaded: true,
        announcementList: action.items,
        meta: action.meta
      });
    case ANNOUNCEMENT_LOAD + ERROR:
      return state.merge({
        loaded: false,
        announcementList: new List(),
        error: action.payload
      });
    default:
      return state;
  }
}

function infrastructureReducer (state, action) {
  switch (action.type) {
    case INFRASTRUCTURE + START:
      return INFRASTRUCTURE_STATE
        .merge({
          realtyId: action.realtyId,
          loading: true
        });

    case INFRASTRUCTURE + SUCCESS:
      return state
        .merge({
          loading: false,
          data: action.payload
        });

    case INFRASTRUCTURE + ERROR:
      return state.merge({
        loading: false,
        error: action.payload
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/Maps/reducer.js